import { company as companyStore } from '@/store/company'
import { user as userStore } from '@/store/user'
import { NotificationActionType } from '../notification'
import { NotificationActionService } from '../NotificationActionService'
import CompanyService from '@/services/CompanyService'
import { RouterRegistry } from '@/util/routerRegistry'
import { locations as locationsStore } from '@/store/location'

let storeInstance: any = null

async function handleTermsAndConditionsAcceptance(data?: any) {
  const router = RouterRegistry.getRouter()
  const company = companyStore.state?.company
  const user = userStore.state?.user
  const tncVersion = data.version

  if (!company || !user || (!user.isAgencyOwner && !user.is_agency_owner)) {
    console.warn('Cannot accept TNC: Missing company, user, or user is not agency owner')
    return
  }

  try {
    // Attempt to accept TNC
    await CompanyService.acceptTnc(company.id, user.id, tncVersion)

    // If TNC acceptance succeeds, refresh notifications
    if (storeInstance) {
      try {
        const options = {
          user: userStore.state?.user,
          location: locationsStore?.currentLocation,
          company: companyStore.state?.company,
          route: router?.currentRoute?.value || {},
        }
        await storeInstance.dispatch('notification/syncAll', options)
      } catch (refreshError) {
        console.warn('Failed to refresh notifications after TNC acceptance:', refreshError)
        // Don't throw - notification refresh failure shouldn't break the TNC acceptance
      }
    }
  } catch (acceptanceError) {
    console.error('Failed to accept Terms and Conditions:', acceptanceError)
  }
}

export const registerRevexNotificationActions = (store: any) => {
  storeInstance = store
  NotificationActionService.registerAction(
    NotificationActionType.TermsAndConditionsAcceptance,
    handleTermsAndConditionsAcceptance
  )
}
